import React from 'react';
import '../Scoreboard/Scoreboard.scss';
import { useAppSelector, useAppDispatch } from '../redux';
import { gameActions } from '../Game/gameSlice';
import { RootState } from '../store';

const Credits = () => {
    const dispatch = useAppDispatch();
    const isCreditsVisible = useAppSelector((state: RootState) => state.game.isCreditsVisible);

    if (!isCreditsVisible) {
        return null;
    }

    const closeCredits = () => {
        dispatch(gameActions.hideCredits());
    };

    return (
        <div className="scoreboard">
            <div className="close" onClick={closeCredits}>x</div>
            <div className="text-heading button-text">Credits</div>
            <div className="scoreboard-entry" style={{ flexDirection: 'column', height: 'auto' }}>
                <h3>Development</h3>
                <p>gdainti</p>
                <p>YuriTheRed</p>
                <p>KaiZenith</p>
                <p>Samuel</p>
                <p>Goffy</p>
            </div>
            <div className="scoreboard-entry" style={{ flexDirection: 'column', height: 'auto' }}>
                <h3>Art & Design</h3>
                <p>gdainti</p>
                <p>KaiZenith</p>
            </div>
            <div className="scoreboard-entry" style={{ flexDirection: 'column', height: 'auto' }}>
                <h3>Music</h3>
                <p>Shaun</p>
            </div>
            <div className="scoreboard-entry" style={{ flexDirection: 'column', height: 'auto' }}>
                <h3>QA</h3>
                <p>Goffy</p>
            </div>
            <div className="button-text center-text" onClick={closeCredits}>Ok</div>
        </div>
    );
};

export default Credits;
